<script lang="ts">
    import MeetingManagerPage from '@Evaluation/AlternativesSurveys/Pages/MeetingManagerPage'
    export default MeetingManagerPage
</script>

<template>
    <div>
        <ScoringSurveyAccessLinks :viewModel="scoringSurveyAccessLinks"
                                  @show-email-sender="handleShowEmailSender"
                                  @download-links="handleDownloadAccessLinks" />

        <ScoringSurveyEmailSender :viewModel="scoringSurveyEmailSender"
                                  @send-email="handleSendEmailCommand" />

        <PanelConsistencyAnalysisDialog :propOpened="consistencyAnalysisOpened" :propRm="consistencyAnalysis"
                                        @show-question="handleShowInconsistentQuestion"
                                        @close-dialog="consistencyAnalysisOpened = false" />

        <DisagreementsReportDialog :propOpened="disagreementsReportOpened" :propRm="disagreementReport"
                                   @show-question="handleShowDisagreementsQuestion"
                                   @close-dialog="disagreementsReportOpened = false" />

        <MeetingStarterDialog :propOpened="meetingStarterOpened" :propSurveyStarted="surveyStarted" :propAutoRevealEnabled="AutoRevealEnabled" :propNamesRevealed="NamesRevealed"
                              @start-meeting="handleStartMeetingCommand"
                              @start-survey="handleStartSurveyCommand"
                              @stop-survey="handleStopSurveyCommand"
                              @toggle-auto-reveal="ToggleAutoRevealCommand"
                              @toggle-names-revealed="ToggleNamesRevealedCommand"
                              @show-access-links="ShowAccessLinksCommand"
                              @close-dialog="meetingStarterOpened = false" />

        <MeetingStopperDialog :propOpened="meetingStopperOpened" :propSurveyStarted="surveyStarted"
                              @stop-meeting="handleStopMeetingCommand"
                              @start-survey="handleStartSurveyCommand"
                              @stop-survey="handleStopSurveyCommand"
                              @close-dialog="meetingStopperOpened = false" />

        <SurveyOpenerDialog :propOpened="surveyOpenerOpened" :propSurveyId="surveyId"
                            @start-survey="handleStartSurveyCommand"
                            @show-access-links="ShowAccessLinksCommand"
                            @close-dialog="surveyOpenerOpened = false" />

        <SurveyCloserDialog :propOpened="surveyCloserOpened" :propSurveyId="surveyId"
                            @stop-survey="handleStopSurveyCommand"
                            @close-dialog="surveyCloserOpened = false" />

        <PortfolioOrDecisionNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <template v-if="Initialized === false">
            <div class="container-fluid" style="padding-top: 130px;">
                <h3><i class="fa fa-spinner fa-spin"></i> Loading...</h3>
            </div>
        </template>

        <template v-if="Initialized === true">

            <nav class="navbar fixed-bottom navbar-dark bg-dark d-flex justify-content-center">
                <div class="btn-group" role="group">
                    <button @click="PreviousQuestionCommand" type="button" class="btn btn-secondary">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> Prev question
                    </button>
                    <button v-if="AnsweredQuestionsCount < surveyQuestionsCount" @click="NextUnansweredQuestionCommand" type="button" class="btn btn-warning" title="Go to next unanswered question">
                        Next unanswered
                    </button>
                    <button v-if="AnsweredQuestionsCount === surveyQuestionsCount" @click="AllDoneCommand" type="button" class="btn btn-success">
                        All done
                    </button>
                    <button @click="NextQuestionCommand" type="button" class="btn btn-secondary">
                        Next question <i class="fa fa-chevron-right" aria-hidden="true"></i>
                    </button>
                </div>
            </nav>

            <div class="container-fluid" style="padding-top: 130px;">
                <div class="row">
                    <div class="col-6">
                        <h6 class="mx-5">
                            <a class="text-dark" v-sanitizedHref="url_ScoringPanelsPage">
                                <i class="fa fa-angle-double-left" aria-hidden="true"></i> Back to scoring
                            </a>
                        </h6>
                        <h1 class="my-0 mx-5" style="font-size: 2em; font-weight: 300; color: #33475b;">Panel: {{surveyName}}</h1>
                    </div>
                    <div class="col-6 col-lg-5 text-right col align-self-end">

                        <div v-if="MeetingStarted === false">
                            <button type="button" class="btn btn-success mr-1" @click="showMeetingStarter">Start Meeting</button>
                            <button v-if="surveyStarted === false" type="button" class="btn btn-outline-secondary mr-1" @click="surveyOpenerOpened = true">Open Survey</button>
                            <button v-if="surveyStarted === true" type="button" class="btn btn-outline-secondary mr-1" @click="surveyCloserOpened = true">Close Survey</button>
                            <button type="button" class="btn btn-outline-secondary mr-1" @click="ShowAccessLinksCommand">Access links</button>

                            <div class="btn-group">
                                <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown">Analyze votes</button>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a class="dropdown-item" @click="showDisagreementsReport">Disagreements</a>
                                    <a class="dropdown-item" @click="showConsistencyAnalysis">Consistency</a>
                                </div>
                            </div>
                        </div>

                        <div v-if="MeetingStarted === true">

                            <div class="btn-group mr-1">
                                <button type="button" class="btn btn-warning mr-1" @click="ToggleVotesRevealedCommand">
                                    <i class="fa-regular fa-fw" :class="VotesRevealed === true ? 'fa-square-check' : 'fa-square'"></i> Reveal votes
                                </button>
                                <button type="button" class="btn btn-warning dropdown-toggle dropdown-toggle-split" data-toggle="dropdown"></button>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a class="dropdown-item px-1" @click.stop="ToggleAutoRevealCommand">
                                        <i class="fa-regular fa-fw" :class="AutoRevealEnabled === true ? 'fa-square-check' : 'fa-square'"></i> Auto reveal
                                    </a>
                                    <a class="dropdown-item px-1" @click.stop="ToggleNamesRevealedCommand">
                                        <i class="fa-regular fa-fw" :class="NamesRevealed === false ? 'fa-square-check' : 'fa-square'"></i> Anonymous
                                    </a>
                                </div>
                            </div>

                            <div class="btn-group mr-1">
                                <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown">
                                    Analyze votes
                                </button>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a class="dropdown-item" @click="showDisagreementsReport">Disagreements</a>
                                    <a class="dropdown-item" @click="showConsistencyAnalysis">Consistency</a>
                                </div>
                            </div>

                            <div class="btn-group">
                                <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown">
                                    Actions
                                </button>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a class="dropdown-item" @click="meetingStopperOpened = true">Stop Meeting</a>
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item" v-if="surveyStarted === false" @click="surveyOpenerOpened = true">Open Survey</a>
                                    <a class="dropdown-item" v-if="surveyStarted === true" @click="surveyCloserOpened = true">Close Survey</a>
                                    <a class="dropdown-item" @click="ShowAccessLinksCommand">Access links</a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <hr style="border-color: #bbb; margin: 20px 0 60px;" />
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12" style="padding-bottom: 100px;">
                        <div class="card">
                            <div class="card-header">
                                Questions <strong>{{AnsweredQuestionsCount}}/{{surveyQuestionsCount}}</strong>
                                <div class="float-right">
                                    <a class="text-dark" @click="SwitchQuestionsOrder">{{QuestionsOrderLabel}}</a>
                                </div>
                            </div>
                            <div class="card-body">
                                <template v-if="QuestionsOrder === 1">
                                    <div class="dropdown">
                                        <a class="h5 dropdown-toggle" data-toggle="dropdown" style="white-space: normal;">
                                            <span>{{CurrentContext?.Name}}</span>
                                        </a>
                                        <div class="dropdown-menu" style="max-height: 300px; overflow-y:auto;">
                                            <div class="input-group px-3 mb-1">
                                                <input type="search" placeholder="Search..." class="form-control" v-model="SearchPhrase">
                                                <span class="input-group-append">
                                                    <span class="input-group-text"><i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i></span>
                                                </span>
                                            </div>
                                            <a v-for="c in EvalContextsView" :key="c.Id" class="dropdown-item" @click="SetCurrentContext(c.Id)">
                                                <span>{{c.Name}}</span><br />
                                                <small>{{c.Path}}</small>
                                            </a>
                                        </div>
                                    </div>

                                    <div class="list-group mt-2">
                                        <a v-for="q in ByContextQuestionsView" :key="q.Id" class="list-group-item list-group-item-action"
                                           @click="SwitchQuestion(q.Id)" :class="{'bg-secondary text-white': q.Id === CurrentQuestionInfo?.Id}">
                                            <i :class="getQuestionCssClass(q)"></i>
                                            {{q.TitleByContext}}
                                        </a>
                                    </div>

                                </template>
                                <template v-if="QuestionsOrder === 2">
                                    <div class="dropdown">
                                        <a class="h5 dropdown-toggle" data-toggle="dropdown" style="white-space: normal;">
                                            <span>{{CurrentAlternative?.Name}}</span>
                                        </a>
                                        <div class="dropdown-menu" style="max-height: 300px; overflow-y:auto;">
                                            <div class="input-group px-3 mb-1">
                                                <input type="search" placeholder="Search..." class="form-control" v-model="SearchPhrase">
                                                <span class="input-group-append">
                                                    <span class="input-group-text"><i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i></span>
                                                </span>
                                            </div>

                                            <a v-for="a in EvalAlternativesView" :key="a.Id" class="dropdown-item" @click="SetCurrentAlternative(a.Id)">
                                                <span>{{a.Name}}</span>
                                            </a>
                                        </div>
                                    </div>

                                    <div class="list-group mt-2">
                                        <a v-for="q in ByAlternativeQuestionsView" :key="q.Id" class="list-group-item list-group-item-action"
                                           @click="SwitchQuestion(q.Id)" :class="{'bg-secondary text-white': q.Id === CurrentQuestionInfo?.Id}">

                                            <i class="mr-1" :class="getQuestionCssClass(q)"></i>
                                            <span>{{q.TitleByAlternative}}</span><br />
                                            <small>{{q.DescriptionByAlternative}}</small>
                                        </a>
                                    </div>
                                </template>

                            </div>
                        </div>
                    </div>

                    <div class="col-lg-7 offset-lg-1 col-md-9 col-sm-8 col-xs-12" style="padding-bottom: 100px;">
                        <MeetingQuestionReview :propIsMeetingManager="true" :propRm="Question"
                                               @update-vote-value="handleSavePanelVoteCommand"
                                               @update-vote-comment="handleSavePanelVoteCommentCommand" />
                    </div>
                </div>
            </div>

        </template>

    </div>
</template>

<style scoped>
    div.Evaluation-MeetingManager {
        width: 100%;
        height: 100%;
        max-height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        margin: 0;
        padding-top: 80px;
        background-color: #fff;
    }
</style>
